import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import clsx from "clsx";
import styles from "./styles.module.css";
import Header from "../../components/Header";
import Loader from "../../components/Loader";
import { TIMEOUT_FOR_ONE_SEC } from "../../appConstants/AppConstant";
import Tabs, { Tab } from "../../components/TabComponent";
import { useLocation } from "react-router-dom";
import TournamentTab from "./TournamentTab";
import LeaderboardTab from "./LeaderboardTab";
import { getNXTournamentInfo, TOURNAMENT } from "./helper";
import useTournamentDetails from "../../api/useTournamentDetails";
import useQueryParams from "../../hooks/useQueryParams";
import { NAVIGATION_ROUTES } from "../../constant";
import LocationCheck from "../../components/LocationCheck/LocationCheck";
import { hideLocationModal } from "../../store/actions/actions";
import { useDispatch } from "react-redux";
import { FbPixelEvent_PageView } from "../../utils/FbPixel/fbPixel";
import { getPartnerId } from "../../utils/helpers/common";
import { FACEBOOK } from "../../utils/helpers/constants";

const TournamentDetails: React.FC = ({}) => {
  const { t } = useTranslation();
  const { tabName } = useParams<{ tabName: string }>();
  const [loading, setLoading] = useState<boolean>(true);
  const { gameName, ltid } = useQueryParams(["gameName", "ltid"]);
  const hasTrackedRef = useRef(false);
  
  useEffect(() => {
    if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      FbPixelEvent_PageView();
    }
  }, []);
  const data = { gameName: gameName ?? "LUDONX", ltid: Number(ltid) ?? 0 };

  const {
    tournamentStatus = "",
    setTournamentCurrentStatus,
    fetchTournamentInfo,
  } = useTournamentDetails(data);
  const tournamentInfo = getNXTournamentInfo();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // console.log("tournamentStatustournamentStatus", tournamentStatus);
  // console.log("tournamentInfotournamentInfo", tournamentInfo);

  const tabMapping: Record<string, number> = {
    tournament: 0,
    leaderboard: 1,
  };

  // Default to the "tournament" tab if tabName is invalid or undefined
  // navigate(`${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/tournament?gameName=${gameName}&ltid=${ltid}`)

  const activeTabIndex = tabMapping[tabName || "tournament"] || 0;
  const handleTabNavigation = (index: number) => {
    const routes = [
      `${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/tournament?gameName=${gameName}&ltid=${ltid}`,
      `${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/leaderboard?gameName=${gameName}&ltid=${ltid}`,
    ];
    navigate(routes[index]);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, TIMEOUT_FOR_ONE_SEC);
    return () => {
      dispatch(hideLocationModal());
    }
  }, []);

  // if (loading) return <Loader transparent />;

  return (
    <>
    {loading && <Loader transparent />}
      <Header pageTitle={t("zupeeLudoLeagueLabel")} />
      <Tabs
        activeTabIndex={activeTabIndex}
        tabsContainerClassName={clsx(styles.tabsContainer, "pageWrapper")}
        onTabChange={handleTabNavigation}
      >
        <Tab label={t("tournament")}>
          <TournamentTab
            tournament={tournamentInfo}
            tournamentStatus={tournamentStatus}
            setTournamentCurrentStatus={setTournamentCurrentStatus}
          />
        </Tab>

        <Tab label={t("leaderboard")}>
          <LeaderboardTab
            tournament={tournamentInfo}
            tournamentStatus={tournamentStatus}
            setTournamentCurrentStatus={setTournamentCurrentStatus}
          />
        </Tab>
      </Tabs>
      <LocationCheck />
    </>
  );
};
export default TournamentDetails;
